import React, { createContext, useContext, useCallback, useEffect, useState } from 'react';
import { api } from './api';
import { useAuth } from './auth';

const CartCtx = createContext(null);

export const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) { setCount(0); return; }
    try {
      const { data } = await api.get('/shop/cart');
      const items = data?.items || [];
      const total = items.reduce((s, i) => s + (i.quantity || 0), 0);
      setCount(total);
    } catch { setCount(0); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <CartCtx.Provider value={{ count, refresh, setCount }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx) || { count: 0, refresh: () => {}, setCount: () => {} };
